import { render, staticRenderFns } from "./NewPricing.vue?vue&type=template&id=0e6f7dac&"
import script from "./NewPricing.vue?vue&type=script&lang=js&"
export * from "./NewPricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports